
<div class="notificationCard__container">
  <div class="notificationCard__dateContainer">{{dailyData?.date}}
    <div class="notificationcard__arrow"><img src="../../../../assets/Images/notification/dateArrow.svg" alt="iconarrow"></div>
  </div>
  <div class="notificationCard__cardwrapper">
    @for (messagestatus of dailyData?.messageinfo; track messagestatus; let last = $last) {
      <div  [ngClass]="last ? 'no-border' : 'notificationCard__card'">
        <app-notification-card-row [messagestatus]="messagestatus"></app-notification-card-row>
      </div>
    }
  </div>

</div>
